import { render, staticRenderFns } from "./StickerFilterButton.vue?vue&type=template&id=8ba94352&scoped=true"
import script from "./StickerFilterButton.vue?vue&type=script&lang=ts"
export * from "./StickerFilterButton.vue?vue&type=script&lang=ts"
import style0 from "./StickerFilterButton.vue?vue&type=style&index=0&id=8ba94352&prod&lang=scss"
import style1 from "./StickerFilterButton.vue?vue&type=style&index=1&id=8ba94352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba94352",
  null
  
)

export default component.exports